import { api, BaseAPI } from '@services/api';

class API extends BaseAPI {
  constructor() {
    super('nnc/critical_analysis');
  }

  update_analysis = async (data: object) => {
    return api.put(this.buildUrl(`update_analysis`), data);
  };
}

export default new API();
